export default function generateClientData(label, data) {
  return {
    label,
    value: data,
  };
}
